// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9363f38f","239":"fbc79437","455":"b94299e1"}[chunkId] + ".chunk.js";
};